import { put,takeEvery } from "@redux-saga/core/effects";
import AxiosCustom from "../../../components/common/apiConfig";

  
  
  export const actionTypes = {
      selectManufacturerBourse:"[selectManufacturerBourse] Action",
      selectManufacturerBourseAsync:"[selectManufacturerBourseAsync] Action",
      selectManufacturerBourseLoading:"[selectManufacturerBourseLoading11] Action"
  }

  const initialState={
      data:[],
      size:20,
      total:0,
      loading:false
  }


  export const bourse_select_manufacturer_reducer = (state=initialState,{type,payload})=>{
    switch (type) {
        case actionTypes.selectManufacturerBourse:
          let data = payload?.results.map((keyItem)=>{
            let id =    Object.keys(keyItem)?.[0]
            return{
              id:id,
              data:keyItem[id]
            }
          })
          return {
            ...state,
            data: data,
            total:data?.length? data?.length : 0
          };
          case actionTypes.selectManufacturerBourseLoading:
            return {
              ...state,
              loading:payload
            };
        default:
          return state;
      }
  }



  function* handleWorker({ payload }) {

    let config = {
      url: "select_request"
    };
  
    let data = {
      table: "imetrade",
      method_type: "select_manufacturer",
      from: payload?.from ? (payload.from - 1) * payload.size : 0,
      size: payload?.size,
      data: payload?.data ? payload.data : {},
      sort_by: payload?.sort_by ? payload?.sort_by :{} ,
    };
  
    try {
      yield put({type:actionTypes.selectManufacturerBourseLoading,payload:true})
      let res = yield AxiosCustom(config, data);  

    //   let flag = handleNotificationAlertTrySelect(res);
      
    //   if (!flag) return;
      
      yield put({
        type: actionTypes.selectManufacturerBourse,
        payload: res.data.response.data
      });
      
    } catch {
    //   handleNotificationAlertCatch();
    }
    finally{
      yield put({type:actionTypes.selectManufacturerBourseLoading,payload:false})
    }
  }
  
  export function* bourseSelectManufacturerWorker() {
    yield takeEvery(actionTypes.selectManufacturerBourseAsync, handleWorker);
  }
  